module.exports = __webpack_public_path__ + "img/qr-code-prod.181ad739.png";